<template>
    <b-card header="Communications"
        header-bg-variant="info"
        header-text-variant="white"
        >
        <form @submit.prevent="submit()" @keydown="form.clearError($event.target.name)">
            <b-row>
                <b-col lg="6" >
                    <b-form-group v-if="['client', 'caregiver'].includes(user.role_type)">

                        <b-form-checkbox name="adjustment" v-model="form.opt_out" value="1">Enable debug mode (returns variables but does not check in)</b-form-checkbox>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="12">
                    <b-button variant="success" type="submit">Save</b-button>
                </b-col>
            </b-row>
        </form>
    </b-card>
</template>

<script>
export default {
    props: {
        'user': {}
    },

    data() {
        return {
            form: new Form({
                opt_out: this.user.opt_out,
            })
        }
    },

    methods: {
        submit() {
            this.form.submit('patch', '/profile/opt-out');
        },
    },
}
</script>
